<template>
    <div class="banner">
		<video width="100%" autoplay="true" muted="true" loop>
		 	<source src="../assets/videos/compilacion_solo.mp4" type="video/mp4">
			Your browser does not support the video tag.
		</video>
        <img src="../assets/img/img_introduccion.jpg" alt="">
		<div class="overlay">
            <div class="contentSlider">
                <slick ref="slick" :options="slickOptions">
                    <div>
                        <div class="contentSlide">
                            <div class="content">
                                <b-row>
                                    <b-col cols="12" lg="6" offset-lg="6">
                                        <h2>
                                            <span>Si tu proceso</span><br>de ventas mejora,<br><span>todo mejora</span>                                        </h2>
                                        <p>+ Hanniel Maldonado</p>
                                        <b-button :to="{name: 'Home', hash: '#contacto'}">Consulta HOY</b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </slick>
            </div>
        </div>
	</div>
</template>

<script>
    import Slick from 'vue-slick'
    export default {
        components: {
            Slick
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    autoplay: false
                },
            };
        },
        methods: {
            next() {
                this.$refs.slick.next()
            },
            prev() {
                this.$refs.slick.prev()
            },
            reInit() {
                this.$refs.slick.reSlick()
            }
        }
    }
</script>

<style scoped>
    .banner{
        position: relative;
    }
    .overlay{
        background-color: rgba(0, 0, 0, 0.8);
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        /* margin-bottom: -15px;  */
        display: flex;
        align-items: center;
    }
    .contentSlider{
        width: 100%;
        height: 100%;
        text-align: right;
    }
    h2, h2 span{
        text-transform: uppercase;
        line-height: 1;
        font-size: 5vw!important;
    }
    h2{
        color: white;
    }
    h2 span{
        color: #EC4802;
    }
    p{
        margin: 35px 0 45px 0;
        color: white;
    }
    .btn{
        width: 200px;
    }
    .slick-slider{
        height: 100%;
        margin-bottom: 0;
    }
    .contentSlide{
        display: flex;
        align-items: center;
    }
    .contentSlide .content{
        height: auto!important;
    }
    img{
        width: 100%;
        display: none;
    }
    @media screen and (max-width: 767px){
        video{
            display: none;
        }
        img{
            display: block;
        }
        h2, h2 span{
            font-size: 28pt!important;
        }
        .contentSlider{
            text-align: left;
        }
    }
</style>

<style>
    .banner .slick-list, .banner .slick-track{
        height: 100%;
    }
    .banner .slick-slide div{
        height: 100%;
    }
    .banner .slick-dots{
        width: 85%;
        left: 50%;
        transform: translate(-50%, 0);
        -webkit-transform: translate(-50%, 0);
        bottom: 30px;
        text-align: right;
    }
    .slick-dots li{
        margin: 0 3px;
    }
    .banner .slick-dots li button:before{
        color: white!important;
        font-size: 11px;
        width: auto;
        height: auto;
        opacity: 0.5!important;
    }
    .slick-dots li.slick-active button:before{
        opacity: 1!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue